export default "__VITE_ASSET__7HCsyE7j__"